import "../../../styles/Buttons.css";
import "../../../styles/Modals.css";
import "../../../styles/Inputs.css";
import "../styles/CalendarStyle.css";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import deleting from "../../../media/delete.png";
import { useState } from "react";
import Modal from "react-modal";
import { useFetch } from "../../../custom/api";

const AddfromCalen = ({
  title,
  mealType,
  image,
  name,
  recipeId,
  date,
  calendarData,
  setCalendarData,
  calendarId,
}) => {
  const { myFetch } = useFetch();
  const [showCModal, setShowCModal] = useState(false);
  const [showMealModal, setShowMealModal] = useState(false);

  const handleOpenMealModal = () => {
    setShowMealModal(true);
  };

  const handleCloseMealModal = () => {
    setShowMealModal(false);
  };

  const handleOpenCModal = () => {
    setShowMealModal(false);
    setShowCModal(true);
  };

  const handleCloseCModal = () => {
    setShowCModal(false);
  };

  const removeMeal = async () => {
    let body = { date, recipe_id: recipeId, meal_type: mealType };
    let resp = await myFetch(`calendar/del`, {
      method: "delete",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    let jsonResponse = await resp.json();
    console.log({ jsonResponse });
    if (jsonResponse.message == "success") {
      setCalendarData(
        calendarData.filter(function (item) {
          return item.calendar_id != calendarId;
        })
      );
    }
  };

  return (
    <>
      <a className="" onClick={handleOpenMealModal}>
        <div to={`/recipe/${recipeId}`} className="centerAlign">
        <div className="grey-2 yekan caption-1">{title}</div>
          <img
            src={image}
            className="box100per radius2 shadow-smooth borderWhite"
          ></img>
           
        </div>
      </a>
      {/* 
      <a className="paddingUpDown3 paddingSide3 marginUpDown2 spc-between b-white radius1">
        <div to={`/recipe/${recipeId}`} className="flex">
          <img src={image} className="box60 radius1"></img>
          <div>
            <div>
              <Link to={`/recipe/${recipeId}`} className="grey-1 heading-3">
                {name}
              </Link>
            </div>
            <div className="grey-2 yekan subject-2">{title}</div>
          </div>
        </div>

        <span
          className="icon-iconclose grey-3 heading-2"
          onClick={handleOpenCModal}
        ></span>
      </a> 
      */}

      <Modal
        isOpen={showCModal}
        onRequestClose={handleCloseCModal}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <img src={deleting} className="marginR10" alt="deleting" />
        </div>
        <div className="modal-body">
          <h2>میخوای غذارو از این وعده حذف کنی؟</h2>
        </div>
        <div className="modal-footer">
          <Link
            to=""
            onClick={removeMeal}
            className="marginBottom0-4r fill-container b-red-1 radius1-5"
          >
            آره حذف میکنم
          </Link>
          <Link
            to=""
            onClick={handleCloseCModal}
            className="b-grey-4 grey-1 fill-container radius1-5"
          >
            منصرف شدم
          </Link>
        </div>
      </Modal>

      <Modal
        isOpen={showMealModal}
        onRequestClose={handleCloseMealModal}
        contentLabel="Date Picker Modal"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-headerr">
          <img src={image} className="box100per top-radius1-5 "></img>
        </div>
        <div className="modal-body">
              <Link to={`/recipe/${recipeId}`} className="grey-1 heading-3">
          <div className="spc-between centerItemAlign">
            <div>
                {name}
              <div className="grey-2 yekan subject-2">{title}</div>
            </div>
            <span className="icon-iconchevron-left heading-3 marginL10"></span>
          </div>
              </Link>
        </div>
        <div className="modal-footer">
          <Link
            to=""
            // onClick={removeMeal}
            className="marginBottom0-4r fill-container b-white red-0 radius1-5 spc-between centerItemAlign"
          >
            این وعده رو حذف میکنم
            <span className="icon-icondelete heading-3 marginL10"></span>
          </Link>
          <Link
            to=""
            onClick={handleCloseMealModal}
            className="b-white grey-2 fill-container radius1-5 spc-between centerItemAlign"
          >
      این وعده رو عوض میکنم
            <span className="icon-iconrepeat heading-3 marginL10"></span>
          </Link>
               <Link
            to=""
            onClick={handleCloseMealModal}
            className="b-grey-4 grey-2 fill-container radius1-5 spc-between centerItemAlign"
          >
            بستن
            <span className="icon-iconclose heading-3 marginL10"></span>
          </Link>
        </div>
      </Modal>
    </>
  );
};

export default AddfromCalen;
